module.exports = __webpack_public_path__ + "img/L_315_0.60db0f05.png";